// Shared loader for self-service plan prices (dev-admin manageable, cached).
import api from "@/lib/api";

export const DEFAULT_PLAN_PRICES = { small: 10, medium: 14, large: 20, giant: 24 };

let _cache = null;
let _promise = null;

export function loadPlanPrices(force = false) {
  if (_cache && !force) return Promise.resolve(_cache);
  if (_promise && !force) return _promise;
  _promise = api
    .get("/store/plan-prices")
    .then((res) => {
      _cache = { ...DEFAULT_PLAN_PRICES, ...(res.data || {}) };
      return _cache;
    })
    .catch(() => {
      _cache = DEFAULT_PLAN_PRICES;
      return _cache;
    })
    .finally(() => {
      _promise = null;
    });
  return _promise;
}
